<div class="sso-container">
    <div class="sso-card">
        <div class="sso-header">
            <div class="logo-container">
                <img src="assets/images/logo.svg?v8" alt="Entra" class="entra-logo">
            </div>
            <h1 class="title">Sign in</h1>
            <p class="subtitle">with corporate accounts</p>
        </div>
        <button class="sso-button" *ngIf="hasEntra" (click)="continueWithEntra()">
            <img src="assets/images/entra.svg" alt="" class="button-icon">
            <span>Continue with Microsoft Entra</span>
        </button>
        <button class="sso-button second" (click)="continueWithGoogleSso()">
            <img src="assets/images/google.svg" alt="" class="button-icon">
            <span>Continue with Google</span>
        </button>
        <button class="sso-button second" (click)="loginWithEmail()">
            <img src="assets/images/rubii_64x64.png" alt="" class="button-icon">
            <span>Login with Rubii account</span>
        </button>
    </div>
</div>
